module.exports = __webpack_public_path__ + "static/media/cloud-c2-v3@2x.927bb0e6.png";